"use strict";
(function () {
    function isAccessibleClick (event) {
        if (event.type === 'click') {
            return true;
        } else if (event.type === 'keypress') {
            var code = event.charCode || event.keyCode;
            if ((code === 32) || (code === 13)) {
                return true;
            }
        } else {
            return false;
        }
    }
    function onPrefButtonClick (event) {
        if (isAccessibleClick(event)) {
            event.preventDefault();
            window.klaro.show();    
        }
    }
    // Enables all cookies for bots / trackers
    window.klaro.addEventListener('render', function (config) {
        if (!/bot|googlebot|crawler|spider|robot|crawling/i.test(navigator.userAgent)) {
            return; // only consent automatically for bots
        }
        var manager = window.klaro.getManager(config);
        manager.changeAll(true); // enable all trackers / third-party services for bots
        manager.saveAndApplyConsents();
    });
    // Show preferences panel when clicking the pref management button.
    var prefButton = document.getElementById('klaroPrefs');
    if (prefButton) {
        prefButton.addEventListener('click', onPrefButtonClick);
        prefButton.addEventListener('keydown', onPrefButtonClick);
    }
})();